// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../webfonts/ar/Questv1-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../webfonts/ar/VIP-Rawy-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../webfonts/SFProARDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../imgs/footer.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  font-family: SFProARDisplay;
  box-sizing: border-box;
}

:root {
  --primary: #0586bc;
  --main-color: #fd6a04;
  --third-color: #fcec00;
  --green-color: #30af0d;
  --side-bar-color: #f0f6fe;
  --white: #fff;
  --black: #000;
  --main-transition: 0.5s;
}

body {
  direction: rtl;
  font-size: 1rem;
}

body:lang(en) {
  direction: ltr;
  /* font-size: 1.2rem; */
}



/* text */

@font-face {
  font-family: Questv1;
  font-style: normal;
  font-weight: 400;
  src: local("Questv1 Regular"), local("Questv1-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-display: swap;


}

/* span  / links */

@font-face {
  font-family: Rawy;
  font-style: normal;
  font-weight: 400;
  src: local("Rawy Regular"), local("Rawy-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-display: swap;


}

/* head */

@font-face {
  font-family: SFProARDisplay;
  font-style: normal;
  font-weight: 400;
  src: local("SFProARDisplay Regular"), local("SFProARDisplay-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-display: swap;

}

main {
  margin-top: 100px;
}

* {
  font-family: Questv1;
}



h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
.fs-1,
.fs-2,
.fs-3,
.fs-4,
.fs-5,
.fs-6 {
  font-family: SFProARDisplay;
}




a,
button,
a *,
button * {
  text-decoration: none;
  font-family: Rawy;
}


ul {
  list-style: none;
  padding-left: 0 !important;
}


a,
button {
  font-family: Rawy;
}

.text-justify {
  text-align: justify;
}

p {
  color: #626262;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: var(--primary) #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 16px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--primary);
  border-radius: 10px;
  border: 3px solid #ffffff;
}

/* Start Nav */
.navbar {
  background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%);
  z-index: 2;
}

.navbar .logo-img {
  height: 100px;
  border-radius: 50%;
  aspect-ratio: 1/1;
  object-fit: contain;
}

@media only screen and (max-width: 768px) {
  .navbar .logo-img {
    height: 80px;
  }
}

.btn-modal {
  background: #fff;
  color: var(--primary);
}

.Dialog {
  width: 50vw;
}

@media only screen and (max-width: 768px) {
  .Dialog {
    width: 95vw;
  }
}

/* عرض اللينكات */

.navbar .nav-link.active,
.navbar .nav-link:hover,
.navbar .btns a i:hover {
  color: #000;
  transition: var(--main-transition);
}

.navbar .btns a i,
.navbar .btns li span {
  /* color: var(--primary) !important;
  margin: 0 5px;
  font-size: 20px; */
}

.nav-link {
  padding: 0.5rem !important;
}

.navbar-toggler-icon {
  background: none;
}

.menuicon {
  display: inline-block;
  cursor: pointer;
}

.btn-check:focus+.btn,
.btn:focus {
  box-shadow: none !important;
}

.p-menubar {
  width: 100%;
  background: transparent;
  color: #fff;
  border: 0 solid #dee2e6;
  justify-content: space-around;
}

.logo .p-menubar {
  justify-content: center !important;
}

@media only screen and (max-width: 768px) {
  .logo .p-menubar {
    justify-content: start !important;
  }
}

.logo .p-menubar-button {
  display: none;
}

.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {
  padding: 0;
}

.SocialMediaIcon .p-menuitem-link:not(.p-disabled):hover {
  background: none !important;
}

.p-menubar .p-menubar-custom,
.p-menubar .p-menubar-end {
  margin-left: 0 !important;
}

.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {
  color: #fff;
}

.p-menubar .p-menuitem {
  margin: 0 5px;
}

.p-menubar .p-menuitem-link,
.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link {
  padding: 0;
}

.p-menubar .p-menuitem.p-menuitem-active .p-submenu-list .nav-link {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.p-submenu-list a {
  position: relative;
}

.p-menuitem-active .nav-link {
  color: #333 !important;
}

.p-menubar-root-list>.p-menuitem-active>.p-submenu-list {
  margin-top: 5px;
  border-radius: 2px;
}

.p-submenu-list a a::before {
  position: absolute;
  content: "";
  top: -0;
  right: 0;
  height: 6px;
  width: 6px;
  background-color: var(--primary);
  transform: translate(0px, 14px);
  border-radius: 50%;
}

/* القائمة الرئسية */
.Items .p-menubar-root-list {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.Items li {
  border-left: 2px solid;
  padding-left: 2px;
}

.navbar .nav-link {
  color: #fff;
  font-size: 14px;
  text-transform: capitalize;
}

/* top bar */
.bg-white .nav-link {
  color: #333;
}

.bg-white .p-menubar-start {
  position: relative;
}

.bg-white .p-menubar-start::before {
  content: "";
  /* position: absolute; */
  width: 50px;
  height: 100%;
  background: red;
  top: 0;
  left: 0;
}

/* end */

/* bg-nav العنوان */
.bg-nav {
  position: relative;
  background: rgb(125, 211, 239);
  border-bottom: 5px solid white;
}

/* triangle */
.triangle-shape::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 1px;
  width: 0;
  height: 100%;
  border-radius: 8px 0 8px 0;
  border-top: 75px solid rgb(125, 211, 239);
  border-left: 75px solid transparent;
  transform: translate(-100%, 0%);
  z-index: 2;
}

.triangle-shape::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 1px;
  width: 4px;
  height: 105px;
  border-radius: 8px;
  background: white;
  transform: translate(-39px, -16px) rotate(-45deg);
  z-index: 2;
}

body:lang(en) .triangle-shape::before {
  right: 1px;
  left: 100%;
  border-top: 75px solid var(--primary);
  border-radius: 0 0 0 0;
  border-top: 75px solid rgb(125, 211, 239);
  border-right: 75px solid transparent;
  border-left: 0;
  transform: translate(0, 0);
  z-index: 2;
}

body:lang(en) .triangle-shape::after {
  right: 1px;
  left: auto;
  transform: translate(42px, -15px) rotate(45deg);
}

/* end */

/* Items_Dowmbar  القائمة الي تحت  */
@media only screen and (min-width: 768px) {
  .Items_Dowmbar {
    transition: 0.5s;
    z-index: 1;
    position: relative;
  }

  /* لما اعمل scroll الجزء ده يختفي  */
  .opacity_false {
    transform: translate(0, -100%);
    opacity: 0;
  }

  .Items_Dowmbar::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: white;
  }

  .Items_Dowmbar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {
    display: flex;
    flex-direction: column;

    background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%) !important;
  }

  .Items_Dowmbar .p-menuitem {
    background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%);
    border-radius: 4px;
  }

  .Items_Dowmbar .p-menuitem-link .p-menuitem-icon,
  .Items_Dowmbar .nav-link {
    color: #000 !important;
    margin-top: 5px;
    font-size: 14px;
  }
}

.Items_Dowmbar .nav-link {
  font-size: 14px;
}

/* القائمة في الموبايل  */
@media only screen and (max-width: 1200px) {
  .p-panelmenu .p-menuitem-text {
    width: 100%;
  }

  .nav-link {
    color: #333 !important;
    margin: 5px 0;
    font-size: 12px;
  }

  .p-panelmenu .p-panelmenu-header>a {
    padding: 0 !important;
    display: flex;
    justify-content: flex-end;
    flex-direction: row-reverse;
  }

  .p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {
    margin-right: auto;
    margin-left: 5px;
  }

  body:lang(en) .p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {
    margin-left: auto;
    margin-right: 5px;
  }

  .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link {
    padding: 0rem 1rem !important;
  }

  .p-sidebar-right {
    justify-content: flex-start !important;
  }
}

/* end */
.owl-theme .owl-nav .owl-prev {
  left: 0;
}

.owl-theme .owl-nav .owl-next {
  left: 50px;
}

.owl-theme .owl-nav [class*='owl-'] {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: -20px;
  transform: translate(100%, -100%);
}

.owl-theme .owl-nav button {
  z-index: 1;
  background: #e8e8e8 !important;
  position: relative;
  border: 1px solid var(--main-color) !important;
  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);
  transition: all 250ms;
  overflow: hidden;
}

.owl-theme .owl-nav button::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 0;
  background-color: var(--main-color);
  z-index: -1;
  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);
  transition: all 250ms
}

.owl-theme .owl-nav button:hover {
  color: #e8e8e8;
}

.owl-theme .owl-nav button:hover::before {
  width: 100%;
}




body:lang(en) .p-submenu-list a a::before {
  position: absolute;
  content: "";
  top: -0;
  left: 0;
  height: 6px;
  width: 6px;
  background-color: var(--main-color);
  transform: translate(0px, 14px);
  border-radius: 50%;
}

.p-menubar .p-submenu-list {
  width: auto !important;
}

nav a.p-menubar-button {
  background: white;
  border-radius: 4px !important;
}

@media screen and (max-width: 960px) {
  .p-dialog[pr_id_2] {
    width: 75vw !important;
  }
}

@media screen and (max-width: 641px) {
  .p-dialog[pr_id_2] {
    width: 100vw !important;
  }
}

/* end */
/* btn-Sidebar */
.btn-Sidebar {
  background: white;
  color: var(--primary);
}

/* modal header */
.modal-body i {
  background-color: var(--main-color);
  color: #fff;
  padding: 10px;
  border-radius: 50%;
  margin-left: 20px;
}

body:lang(en) .modal-body i {
  margin-left: 0;
  margin-right: 20px;
}

.modal-body h4 {
  color: var(--main-color);
}

.modal-body p {
  font-size: 15px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow-y: clip;
  -webkit-box-orient: vertical;
  color: #626262;
}

/* end */

/* table  */

.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {
  background-color: var(--primary);
  color: white;
}

.p-datatable.p-datatable-sm .p-datatable-tbody>tr>td,
.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {
  white-space: nowrap;
}

.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  margin: 0 !important;
}

body:lang(ar) .p-dropdown .p-dropdown-clear-icon {
  left: 3rem;
  right: auto;
}

body:lang(ar) .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {
  padding-left: 1.75rem;
  padding-right: 0.75rem;
}

body:lang(ar) .p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {
  right: auto;
  left: 0.75rem;
  color: #6c757d;
}

body:lang(ar) .p-paginator .p-dropdown {
  margin-right: 0.5rem;
  margin-right: 0rem;
}

body:lang(ar) .p-paginator .p-dropdown .p-dropdown-label {
  padding-right: 0.75rem;
  padding-left: 0;
}

body:lang(ar) .p-inputtext.p-inputmask {
  direction: ltr;
  text-align: right;
}

body:lang(ar) .p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {
  margin: 0 1rem 0 0;
}

.p-tabview .p-tabview-nav {
  overflow-x: scroll;
  overflow-y: hidden;
}

/* table  */

/* library_information links */

.links .active,
.library_information .links .active {
  background-color: var(--primary);
  color: white;
  border: 2px solid white;
  /* transform: scale(1.1); */
}

.links .active span,
.library_information .links .active span {
  background-color: var(--primary);
  color: white;
  transform: scale(1.1);
}

aside a.active {
  border: 1px solid white !important;
  background-color: var(--primary) !important;
  color: white !important;
}

aside a.active span {
  background-color: white !important;
  color: var(--primary) !important;
}

.p-button .p-button-icon-left {
  margin-right: 0rem;
  margin-left: 0.5rem;
}

/* library_information links */

body:lang(ar) .p-organizationchart .p-organizationchart-line-left {
  border-right: 0 solid #dee2e6 !important;
  border-left: 1px solid #dee2e6;
}

.flex {
  display: flex;
}

/* forms */

body:lang(ar) .p-inputgroup-addon:first-child,
body:lang(ar) .p-inputgroup button:first-child,
body:lang(ar) .p-inputgroup input:first-child,
body:lang(ar) .p-inputgroup>.p-inputwrapper:first-child,
body:lang(ar) .p-inputgroup>.p-inputwrapper:first-child>.p-inputtext {
  border-radius: 0 6px 6px 0;
}

body:lang(ar) .p-inputgroup-addon:last-child,
.p-inputgroup button:last-child,
.p-inputgroup input:last-child,
.p-inputgroup>.p-inputwrapper:last-child,
.p-inputgroup>.p-inputwrapper:last-child>.p-inputtext {
  border-radius: 6px 0 0 6px;
}

body:lang(ar) .p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {
  margin-left: 0.5rem;
  margin-right: 0rem;
}

/* timeline */
.img-doctor img {
  height: 250px;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 50%;
  padding: 10px;
  border: 1px solid var(--primary);
}

.p-component .p-card-body {
  text-align: right;
  padding: 1rem !important;
}

.p-card-content {
  padding: 0 !important;
}

.p-timeline-left .p-timeline-event-opposite {
  display: none;
}

.p-card .p-card-subtitle {
  display: inline;
  padding: 10px;
  background: #e7e7e7;
  border-radius: 4px;
}

.des {
  color: var(--primary);
}

@media screen and (max-width: 991px) {
  .customized-timeline .p-timeline-event:nth-child(even) {
    flex-direction: row !important;
  }

  .customized-timeline .p-timeline-event:nth-child(even) .p-timeline-event-content {
    text-align: left !important;
  }

  .customized-timeline .p-timeline-event-opposite {
    flex: 0 1;
  }

  .customized-timeline .p-card {
    margin-top: 1rem;
  }

  .p-component .p-card-body,
  .p-tabview .p-tabview-panels {
    padding: 0.2rem !important;
  }
}

.p-carousel {
  direction: ltr;
}

.p-carousel .p-carousel-content .p-carousel-prev,
.p-carousel .p-carousel-content .p-carousel-next {
  display: none;
}

/*  */
.owl-carousel {
  direction: ltr;
}

/* Footer */

.footer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center;
  background-size: 100% 100%;
}

.foot-content {
  position: relative;
  color: #fff;
}

footer a {
  color: rgb(255 255 255 / 80%);
  transition: var(--main-transition);
}

.foot-links .foot-link.active {
  color: var(--main-color);
}

footer a:hover {
  color: var(--main-color);
}

footer .foot-title h5 {
  line-height: 1.5;
}

footer .foot-title p {
  color: rgb(255 255 255 / 80%);
  text-align: justify;
  display: -webkit-box;
  overflow-y: clip;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

footer h6 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  padding-bottom: 10px;
}

footer h6::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #fff;
}

footer h6::before {
  position: absolute;
  content: "";
  bottom: -3px;
  right: -2px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: #fff;
}

footer ul {
  margin-top: 20px;
}

footer ul li {
  padding-bottom: 20px;
}

footer ul li i {
  margin-right: 8px;
}



.foot-title img {
  width: 200px;
  margin-left: 30px;
  height: 200px;
  border-radius: 50%;
}

.foot-content .foot-contact .conatact-us-list li {
  display: flex;
  align-items: center;
}

body:lang(en) .foot-content .foot-contact .conatact-us-list span {
  margin-left: 0;
  margin-right: 10px;
}

.foot-content .foot-contact .conatact-us-list span {
  background-color: #fff;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.foot-content .foot-links i {
  margin-left: 10px;
}

body:lang(en) .foot-content .foot-links i {
  transform: scaleX(-1);
}

.foot-content .foot-contact .conatact-us-list i {
  color: var(--primary);
  margin-right: 0;
}

.foot-content .allRight p {
  color: white;
}

.foot-content .allRight a {
  color: var(--main-color) !important;
}

.foot-content .allRight p {
  font-weight: 600;
}

@media (min-width: 320px) and (max-width: 767px) {
  footer {
    background-color: var(--primary);
    background-image: none;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  footer ul li {
    padding-bottom: 10px;
  }
}

@media (min-width: 320px) and (max-width: 990px) {
  .foot-title img {
    width: 150px;
    height: 150px;
  }

  footer .foot-title p {
    -webkit-line-clamp: 8;
    text-align: justify;
  }
}

@media (min-width: 1440px) {
  .foot-content .row:first-child {
    /* width: 80%; */
    margin-right: 10%;
  }
}

.btn-up {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: white !important;
  transition: 0.8s;
  transform: translateX(-100px);
  z-index: 100;
}

.btn-up.active {
  transform: translateX(0);
}

.btn-up:hover {
  background-color: var(--primary) !important;
  color: white !important;
}

.dir-ltr {
  direction: ltr !important;
}

.p-panel .p-panel-content {
  padding: 0.5rem 1rem;
}


/* btn SocialMediaIcon */

.Btn {
  color: white;
  font-size: 15px;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.svgContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  -webkit-backdrop-filter: blur(0px);
          backdrop-filter: blur(0px);
  letter-spacing: 0.8px;
  border-radius: 4px;
  transition: all 0.3s;
  z-index: 1;
}

.BG {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;

  z-index: 0;
  border-radius: 6px;
  pointer-events: none;
  transition: all 0.3s;
}

.facebook {
  background: #1877f2;
}

.instagram {
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
}

.twitter {
  background: #1DA1F2;
}

.tiktok {
  background: #181818;
}

.youtube {
  background: #FF0000;
}

.whatsapp {
  background: #25d366;
}

.phone {
  background: var(--primary);
}

.mail {
  background: var(--main-color);
}

.Btn:hover .BG {
  transform: rotate(35deg);
  transform-origin: bottom;
  z-index: 0;
}

.Btn:hover .svgContainer {
  border: 1px solid rgba(230, 230, 230, 0.466);
  background-color: rgba(204, 204, 204, 0.466);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 1;
}

.icon:hover {
  color: white;
}

@media (max-width:1200px) {
  .nav-student {
    background-color: #0586bc;
    color: white;
    z-index: 100;
    width: 100%;
  }

  /* .p-menuitem a {
      color: white !important;
    } */

}

.Graduates-sections {
  margin-top: 150px !important;
}

/* .Graduates-sections a {
  text-align: right;

}
.aside-Graduates .actives{
background-color: #0586bc !important;
} */
/* Start modal shown  */
.modal-content-home .modal-content {
  width: 750px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0);
}

.modal-content-home .btn-close-modal {
  position: absolute;
  left: 20px;
}

@media (max-width:768px) {
  .modal-content-home .modal-content {
    width: 500px !important;
  }
}

@media (max-width:567px) {
  .modal-content-home .modal-content {
    width: 300px !important;
  }
}

/* End modal shown  */`, "",{"version":3,"sources":["webpack://./src/assets/css/global/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;;;AAIA,SAAS;;AAET;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC8D;EAC9D,kBAAkB;;;AAGpB;;AAEA,kBAAkB;;AAElB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB;2DAC+D;EAC/D,kBAAkB;;;AAGpB;;AAEA,SAAS;;AAET;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB;2DACiE;EACjE,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;;;AAIA;;;;;;;;;;;;;;;;;;EAkBE,2BAA2B;AAC7B;;;;;AAKA;;;;EAIE,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;;AAGA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B,YAAY;AACZ;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,4EAA4E;EAC5E,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;;AAEjB;;;EAGE,WAAW;EACX,kCAAkC;AACpC;;AAEA;;EAEE;;oBAEkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA,QAAQ;;AAER,mBAAmB;AACnB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,yCAAyC;EACzC,mCAAmC;EACnC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,qCAAqC;EACrC,sBAAsB;EACtB,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,+CAA+C;AACjD;;AAEA,QAAQ;;AAER,oCAAoC;AACpC;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB,uFAAuF;EACzF;;EAEA;IACE,4EAA4E;IAC5E,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;AACF;;AAEA,QAAQ;AACR;EACE,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,8CAA8C;EAE9C,iDAAiD;EACjD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,mCAAmC;EACnC,WAAW;EAEX,iDAAiD;EACjD;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;;;AAKA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,OAAO;EACP,WAAW;EACX,UAAU;EACV,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,QAAQ;AACR,gBAAgB;AAChB;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,QAAQ;;AAER,WAAW;;AAEX;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,WAAW;;AAEX,8BAA8B;;AAE9B;;EAEE,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8BAA8B;;AAE9B;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;;AAEV;;;;;EAKE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA,KAAK;AACL;EACE,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,yDAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;;AAGA,wBAAwB;;AAExB;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAA0B;UAA1B,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;;EAEZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EAGnB,mGAAmG;EACnG,kHAAkH;AACpH;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,kCAA0B;UAA1B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;;OAEK;;AAEP;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;GAMG;AACH,uBAAuB;AACvB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,qBAAqB","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  font-family: SFProARDisplay;\n  box-sizing: border-box;\n}\n\n:root {\n  --primary: #0586bc;\n  --main-color: #fd6a04;\n  --third-color: #fcec00;\n  --green-color: #30af0d;\n  --side-bar-color: #f0f6fe;\n  --white: #fff;\n  --black: #000;\n  --main-transition: 0.5s;\n}\n\nbody {\n  direction: rtl;\n  font-size: 1rem;\n}\n\nbody:lang(en) {\n  direction: ltr;\n  /* font-size: 1.2rem; */\n}\n\n\n\n/* text */\n\n@font-face {\n  font-family: Questv1;\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Questv1 Regular\"), local(\"Questv1-Regular\"),\n    url(\"../../webfonts/ar/Questv1-Regular.otf\") format(\"woff2\");\n  font-display: swap;\n\n\n}\n\n/* span  / links */\n\n@font-face {\n  font-family: Rawy;\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Rawy Regular\"), local(\"Rawy-Regular\"),\n    url(\"../../webfonts/ar/VIP-Rawy-Regular.ttf\") format(\"woff2\");\n  font-display: swap;\n\n\n}\n\n/* head */\n\n@font-face {\n  font-family: SFProARDisplay;\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"SFProARDisplay Regular\"), local(\"SFProARDisplay-Regular\"),\n    url(\"../../webfonts/SFProARDisplay-Medium.ttf\") format(\"woff2\");\n  font-display: swap;\n\n}\n\nmain {\n  margin-top: 100px;\n}\n\n* {\n  font-family: Questv1;\n}\n\n\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\n.fs-1,\n.fs-2,\n.fs-3,\n.fs-4,\n.fs-5,\n.fs-6 {\n  font-family: SFProARDisplay;\n}\n\n\n\n\na,\nbutton,\na *,\nbutton * {\n  text-decoration: none;\n  font-family: Rawy;\n}\n\n\nul {\n  list-style: none;\n  padding-left: 0 !important;\n}\n\n\na,\nbutton {\n  font-family: Rawy;\n}\n\n.text-justify {\n  text-align: justify;\n}\n\np {\n  color: #626262;\n}\n\n/* ===== Scrollbar CSS ===== */\n/* Firefox */\n* {\n  scrollbar-width: auto;\n  scrollbar-color: var(--primary) #ffffff;\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 16px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--primary);\n  border-radius: 10px;\n  border: 3px solid #ffffff;\n}\n\n/* Start Nav */\n.navbar {\n  background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%);\n  z-index: 2;\n}\n\n.navbar .logo-img {\n  height: 100px;\n  border-radius: 50%;\n  aspect-ratio: 1/1;\n  object-fit: contain;\n}\n\n@media only screen and (max-width: 768px) {\n  .navbar .logo-img {\n    height: 80px;\n  }\n}\n\n.btn-modal {\n  background: #fff;\n  color: var(--primary);\n}\n\n.Dialog {\n  width: 50vw;\n}\n\n@media only screen and (max-width: 768px) {\n  .Dialog {\n    width: 95vw;\n  }\n}\n\n/* عرض اللينكات */\n\n.navbar .nav-link.active,\n.navbar .nav-link:hover,\n.navbar .btns a i:hover {\n  color: #000;\n  transition: var(--main-transition);\n}\n\n.navbar .btns a i,\n.navbar .btns li span {\n  /* color: var(--primary) !important;\n  margin: 0 5px;\n  font-size: 20px; */\n}\n\n.nav-link {\n  padding: 0.5rem !important;\n}\n\n.navbar-toggler-icon {\n  background: none;\n}\n\n.menuicon {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.btn-check:focus+.btn,\n.btn:focus {\n  box-shadow: none !important;\n}\n\n.p-menubar {\n  width: 100%;\n  background: transparent;\n  color: #fff;\n  border: 0 solid #dee2e6;\n  justify-content: space-around;\n}\n\n.logo .p-menubar {\n  justify-content: center !important;\n}\n\n@media only screen and (max-width: 768px) {\n  .logo .p-menubar {\n    justify-content: start !important;\n  }\n}\n\n.logo .p-menubar-button {\n  display: none;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {\n  padding: 0;\n}\n\n.SocialMediaIcon .p-menuitem-link:not(.p-disabled):hover {\n  background: none !important;\n}\n\n.p-menubar .p-menubar-custom,\n.p-menubar .p-menubar-end {\n  margin-left: 0 !important;\n}\n\n.p-menubar .p-menubar-root-list>.p-menuitem>.p-menuitem-link .p-submenu-icon {\n  color: #fff;\n}\n\n.p-menubar .p-menuitem {\n  margin: 0 5px;\n}\n\n.p-menubar .p-menuitem-link,\n.p-menubar .p-menuitem.p-menuitem-active>.p-menuitem-link {\n  padding: 0;\n}\n\n.p-menubar .p-menuitem.p-menuitem-active .p-submenu-list .nav-link {\n  font-size: 14px;\n  color: #333;\n  white-space: nowrap;\n}\n\n.p-submenu-list a {\n  position: relative;\n}\n\n.p-menuitem-active .nav-link {\n  color: #333 !important;\n}\n\n.p-menubar-root-list>.p-menuitem-active>.p-submenu-list {\n  margin-top: 5px;\n  border-radius: 2px;\n}\n\n.p-submenu-list a a::before {\n  position: absolute;\n  content: \"\";\n  top: -0;\n  right: 0;\n  height: 6px;\n  width: 6px;\n  background-color: var(--primary);\n  transform: translate(0px, 14px);\n  border-radius: 50%;\n}\n\n/* القائمة الرئسية */\n.Items .p-menubar-root-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.Items li {\n  border-left: 2px solid;\n  padding-left: 2px;\n}\n\n.navbar .nav-link {\n  color: #fff;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n\n/* top bar */\n.bg-white .nav-link {\n  color: #333;\n}\n\n.bg-white .p-menubar-start {\n  position: relative;\n}\n\n.bg-white .p-menubar-start::before {\n  content: \"\";\n  /* position: absolute; */\n  width: 50px;\n  height: 100%;\n  background: red;\n  top: 0;\n  left: 0;\n}\n\n/* end */\n\n/* bg-nav العنوان */\n.bg-nav {\n  position: relative;\n  background: rgb(125, 211, 239);\n  border-bottom: 5px solid white;\n}\n\n/* triangle */\n.triangle-shape::before {\n  content: \"\";\n  position: absolute;\n  top: 0px;\n  left: 1px;\n  width: 0;\n  height: 100%;\n  border-radius: 8px 0 8px 0;\n  border-top: 75px solid rgb(125, 211, 239);\n  border-left: 75px solid transparent;\n  transform: translate(-100%, 0%);\n  z-index: 2;\n}\n\n.triangle-shape::after {\n  content: \"\";\n  position: absolute;\n  top: 0px;\n  left: 1px;\n  width: 4px;\n  height: 105px;\n  border-radius: 8px;\n  background: white;\n  transform: translate(-39px, -16px) rotate(-45deg);\n  z-index: 2;\n}\n\nbody:lang(en) .triangle-shape::before {\n  right: 1px;\n  left: 100%;\n  border-top: 75px solid var(--primary);\n  border-radius: 0 0 0 0;\n  border-top: 75px solid rgb(125, 211, 239);\n  border-right: 75px solid transparent;\n  border-left: 0;\n  transform: translate(0, 0);\n  z-index: 2;\n}\n\nbody:lang(en) .triangle-shape::after {\n  right: 1px;\n  left: auto;\n  transform: translate(42px, -15px) rotate(45deg);\n}\n\n/* end */\n\n/* Items_Dowmbar  القائمة الي تحت  */\n@media only screen and (min-width: 768px) {\n  .Items_Dowmbar {\n    transition: 0.5s;\n    z-index: 1;\n    position: relative;\n  }\n\n  /* لما اعمل scroll الجزء ده يختفي  */\n  .opacity_false {\n    transform: translate(0, -100%);\n    opacity: 0;\n  }\n\n  .Items_Dowmbar::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    background-color: white;\n  }\n\n  .Items_Dowmbar .p-menubar-root-list>.p-menuitem>.p-menuitem-link {\n    display: flex;\n    flex-direction: column;\n\n    background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%) !important;\n  }\n\n  .Items_Dowmbar .p-menuitem {\n    background: linear-gradient(0deg, rgb(125, 211, 239), rgb(1, 135, 192) 100%);\n    border-radius: 4px;\n  }\n\n  .Items_Dowmbar .p-menuitem-link .p-menuitem-icon,\n  .Items_Dowmbar .nav-link {\n    color: #000 !important;\n    margin-top: 5px;\n    font-size: 14px;\n  }\n}\n\n.Items_Dowmbar .nav-link {\n  font-size: 14px;\n}\n\n/* القائمة في الموبايل  */\n@media only screen and (max-width: 1200px) {\n  .p-panelmenu .p-menuitem-text {\n    width: 100%;\n  }\n\n  .nav-link {\n    color: #333 !important;\n    margin: 5px 0;\n    font-size: 12px;\n  }\n\n  .p-panelmenu .p-panelmenu-header>a {\n    padding: 0 !important;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: row-reverse;\n  }\n\n  .p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {\n    margin-right: auto;\n    margin-left: 5px;\n  }\n\n  body:lang(en) .p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon {\n    margin-left: auto;\n    margin-right: 5px;\n  }\n\n  .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link {\n    padding: 0rem 1rem !important;\n  }\n\n  .p-sidebar-right {\n    justify-content: flex-start !important;\n  }\n}\n\n/* end */\n.owl-theme .owl-nav .owl-prev {\n  left: 0;\n}\n\n.owl-theme .owl-nav .owl-next {\n  left: 50px;\n}\n\n.owl-theme .owl-nav [class*='owl-'] {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: absolute;\n  top: -20px;\n  transform: translate(100%, -100%);\n}\n\n.owl-theme .owl-nav button {\n  z-index: 1;\n  background: #e8e8e8 !important;\n  position: relative;\n  border: 1px solid var(--main-color) !important;\n  -webkit-box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  transition: all 250ms;\n  overflow: hidden;\n}\n\n.owl-theme .owl-nav button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 0;\n  background-color: var(--main-color);\n  z-index: -1;\n  -webkit-box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  box-shadow: 4px 8px 19px -3px rgba(0, 0, 0, 0.27);\n  transition: all 250ms\n}\n\n.owl-theme .owl-nav button:hover {\n  color: #e8e8e8;\n}\n\n.owl-theme .owl-nav button:hover::before {\n  width: 100%;\n}\n\n\n\n\nbody:lang(en) .p-submenu-list a a::before {\n  position: absolute;\n  content: \"\";\n  top: -0;\n  left: 0;\n  height: 6px;\n  width: 6px;\n  background-color: var(--main-color);\n  transform: translate(0px, 14px);\n  border-radius: 50%;\n}\n\n.p-menubar .p-submenu-list {\n  width: auto !important;\n}\n\nnav a.p-menubar-button {\n  background: white;\n  border-radius: 4px !important;\n}\n\n@media screen and (max-width: 960px) {\n  .p-dialog[pr_id_2] {\n    width: 75vw !important;\n  }\n}\n\n@media screen and (max-width: 641px) {\n  .p-dialog[pr_id_2] {\n    width: 100vw !important;\n  }\n}\n\n/* end */\n/* btn-Sidebar */\n.btn-Sidebar {\n  background: white;\n  color: var(--primary);\n}\n\n/* modal header */\n.modal-body i {\n  background-color: var(--main-color);\n  color: #fff;\n  padding: 10px;\n  border-radius: 50%;\n  margin-left: 20px;\n}\n\nbody:lang(en) .modal-body i {\n  margin-left: 0;\n  margin-right: 20px;\n}\n\n.modal-body h4 {\n  color: var(--main-color);\n}\n\n.modal-body p {\n  font-size: 15px;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  overflow-y: clip;\n  -webkit-box-orient: vertical;\n  color: #626262;\n}\n\n/* end */\n\n/* table  */\n\n.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {\n  background-color: var(--primary);\n  color: white;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-tbody>tr>td,\n.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {\n  white-space: nowrap;\n}\n\n.p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n  margin: 0 !important;\n}\n\nbody:lang(ar) .p-dropdown .p-dropdown-clear-icon {\n  left: 3rem;\n  right: auto;\n}\n\nbody:lang(ar) .p-dropdown-panel .p-dropdown-header .p-dropdown-filter {\n  padding-left: 1.75rem;\n  padding-right: 0.75rem;\n}\n\nbody:lang(ar) .p-dropdown-panel .p-dropdown-header .p-dropdown-filter-icon {\n  right: auto;\n  left: 0.75rem;\n  color: #6c757d;\n}\n\nbody:lang(ar) .p-paginator .p-dropdown {\n  margin-right: 0.5rem;\n  margin-right: 0rem;\n}\n\nbody:lang(ar) .p-paginator .p-dropdown .p-dropdown-label {\n  padding-right: 0.75rem;\n  padding-left: 0;\n}\n\nbody:lang(ar) .p-inputtext.p-inputmask {\n  direction: ltr;\n  text-align: right;\n}\n\nbody:lang(ar) .p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {\n  margin: 0 1rem 0 0;\n}\n\n.p-tabview .p-tabview-nav {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n\n/* table  */\n\n/* library_information links */\n\n.links .active,\n.library_information .links .active {\n  background-color: var(--primary);\n  color: white;\n  border: 2px solid white;\n  /* transform: scale(1.1); */\n}\n\n.links .active span,\n.library_information .links .active span {\n  background-color: var(--primary);\n  color: white;\n  transform: scale(1.1);\n}\n\naside a.active {\n  border: 1px solid white !important;\n  background-color: var(--primary) !important;\n  color: white !important;\n}\n\naside a.active span {\n  background-color: white !important;\n  color: var(--primary) !important;\n}\n\n.p-button .p-button-icon-left {\n  margin-right: 0rem;\n  margin-left: 0.5rem;\n}\n\n/* library_information links */\n\nbody:lang(ar) .p-organizationchart .p-organizationchart-line-left {\n  border-right: 0 solid #dee2e6 !important;\n  border-left: 1px solid #dee2e6;\n}\n\n.flex {\n  display: flex;\n}\n\n/* forms */\n\nbody:lang(ar) .p-inputgroup-addon:first-child,\nbody:lang(ar) .p-inputgroup button:first-child,\nbody:lang(ar) .p-inputgroup input:first-child,\nbody:lang(ar) .p-inputgroup>.p-inputwrapper:first-child,\nbody:lang(ar) .p-inputgroup>.p-inputwrapper:first-child>.p-inputtext {\n  border-radius: 0 6px 6px 0;\n}\n\nbody:lang(ar) .p-inputgroup-addon:last-child,\n.p-inputgroup button:last-child,\n.p-inputgroup input:last-child,\n.p-inputgroup>.p-inputwrapper:last-child,\n.p-inputgroup>.p-inputwrapper:last-child>.p-inputtext {\n  border-radius: 6px 0 0 6px;\n}\n\nbody:lang(ar) .p-multiselect-panel .p-multiselect-items .p-multiselect-item .p-checkbox {\n  margin-left: 0.5rem;\n  margin-right: 0rem;\n}\n\n/* timeline */\n.img-doctor img {\n  height: 250px;\n  aspect-ratio: 1/1;\n  object-fit: cover;\n  border-radius: 50%;\n  padding: 10px;\n  border: 1px solid var(--primary);\n}\n\n.p-component .p-card-body {\n  text-align: right;\n  padding: 1rem !important;\n}\n\n.p-card-content {\n  padding: 0 !important;\n}\n\n.p-timeline-left .p-timeline-event-opposite {\n  display: none;\n}\n\n.p-card .p-card-subtitle {\n  display: inline;\n  padding: 10px;\n  background: #e7e7e7;\n  border-radius: 4px;\n}\n\n.des {\n  color: var(--primary);\n}\n\n@media screen and (max-width: 991px) {\n  .customized-timeline .p-timeline-event:nth-child(even) {\n    flex-direction: row !important;\n  }\n\n  .customized-timeline .p-timeline-event:nth-child(even) .p-timeline-event-content {\n    text-align: left !important;\n  }\n\n  .customized-timeline .p-timeline-event-opposite {\n    flex: 0;\n  }\n\n  .customized-timeline .p-card {\n    margin-top: 1rem;\n  }\n\n  .p-component .p-card-body,\n  .p-tabview .p-tabview-panels {\n    padding: 0.2rem !important;\n  }\n}\n\n.p-carousel {\n  direction: ltr;\n}\n\n.p-carousel .p-carousel-content .p-carousel-prev,\n.p-carousel .p-carousel-content .p-carousel-next {\n  display: none;\n}\n\n/*  */\n.owl-carousel {\n  direction: ltr;\n}\n\n/* Footer */\n\n.footer {\n  background-image: url(../../imgs/footer.webp);\n  background-position: center;\n  background-size: 100% 100%;\n}\n\n.foot-content {\n  position: relative;\n  color: #fff;\n}\n\nfooter a {\n  color: rgb(255 255 255 / 80%);\n  transition: var(--main-transition);\n}\n\n.foot-links .foot-link.active {\n  color: var(--main-color);\n}\n\nfooter a:hover {\n  color: var(--main-color);\n}\n\nfooter .foot-title h5 {\n  line-height: 1.5;\n}\n\nfooter .foot-title p {\n  color: rgb(255 255 255 / 80%);\n  text-align: justify;\n  display: -webkit-box;\n  overflow-y: clip;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;\n}\n\nfooter h6 {\n  position: relative;\n  width: fit-content;\n  padding-bottom: 10px;\n}\n\nfooter h6::after {\n  position: absolute;\n  content: \"\";\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: #fff;\n}\n\nfooter h6::before {\n  position: absolute;\n  content: \"\";\n  bottom: -3px;\n  right: -2px;\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n  background-color: #fff;\n}\n\nfooter ul {\n  margin-top: 20px;\n}\n\nfooter ul li {\n  padding-bottom: 20px;\n}\n\nfooter ul li i {\n  margin-right: 8px;\n}\n\n\n\n.foot-title img {\n  width: 200px;\n  margin-left: 30px;\n  height: 200px;\n  border-radius: 50%;\n}\n\n.foot-content .foot-contact .conatact-us-list li {\n  display: flex;\n  align-items: center;\n}\n\nbody:lang(en) .foot-content .foot-contact .conatact-us-list span {\n  margin-left: 0;\n  margin-right: 10px;\n}\n\n.foot-content .foot-contact .conatact-us-list span {\n  background-color: #fff;\n  padding: 5px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.foot-content .foot-links i {\n  margin-left: 10px;\n}\n\nbody:lang(en) .foot-content .foot-links i {\n  transform: scaleX(-1);\n}\n\n.foot-content .foot-contact .conatact-us-list i {\n  color: var(--primary);\n  margin-right: 0;\n}\n\n.foot-content .allRight p {\n  color: white;\n}\n\n.foot-content .allRight a {\n  color: var(--main-color) !important;\n}\n\n.foot-content .allRight p {\n  font-weight: 600;\n}\n\n@media (min-width: 320px) and (max-width: 767px) {\n  footer {\n    background-color: var(--primary);\n    background-image: none;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  footer ul li {\n    padding-bottom: 10px;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 990px) {\n  .foot-title img {\n    width: 150px;\n    height: 150px;\n  }\n\n  footer .foot-title p {\n    -webkit-line-clamp: 8;\n    text-align: justify;\n  }\n}\n\n@media (min-width: 1440px) {\n  .foot-content .row:first-child {\n    /* width: 80%; */\n    margin-right: 10%;\n  }\n}\n\n.btn-up {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  background-color: white !important;\n  transition: 0.8s;\n  transform: translateX(-100px);\n  z-index: 100;\n}\n\n.btn-up.active {\n  transform: translateX(0);\n}\n\n.btn-up:hover {\n  background-color: var(--primary) !important;\n  color: white !important;\n}\n\n.dir-ltr {\n  direction: ltr !important;\n}\n\n.p-panel .p-panel-content {\n  padding: 0.5rem 1rem;\n}\n\n\n/* btn SocialMediaIcon */\n\n.Btn {\n  color: white;\n  font-size: 15px;\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  position: relative;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.svgContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  backdrop-filter: blur(0px);\n  letter-spacing: 0.8px;\n  border-radius: 4px;\n  transition: all 0.3s;\n  z-index: 1;\n}\n\n.BG {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n\n  z-index: 0;\n  border-radius: 6px;\n  pointer-events: none;\n  transition: all 0.3s;\n}\n\n.facebook {\n  background: #1877f2;\n}\n\n.instagram {\n  background: #f09433;\n  background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  background: -webkit-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);\n}\n\n.twitter {\n  background: #1DA1F2;\n}\n\n.tiktok {\n  background: #181818;\n}\n\n.youtube {\n  background: #FF0000;\n}\n\n.whatsapp {\n  background: #25d366;\n}\n\n.phone {\n  background: var(--primary);\n}\n\n.mail {\n  background: var(--main-color);\n}\n\n.Btn:hover .BG {\n  transform: rotate(35deg);\n  transform-origin: bottom;\n  z-index: 0;\n}\n\n.Btn:hover .svgContainer {\n  border: 1px solid rgba(230, 230, 230, 0.466);\n  background-color: rgba(204, 204, 204, 0.466);\n  backdrop-filter: blur(4px);\n  z-index: 1;\n}\n\n.icon:hover {\n  color: white;\n}\n\n@media (max-width:1200px) {\n  .nav-student {\n    background-color: #0586bc;\n    color: white;\n    z-index: 100;\n    width: 100%;\n  }\n\n  /* .p-menuitem a {\n      color: white !important;\n    } */\n\n}\n\n.Graduates-sections {\n  margin-top: 150px !important;\n}\n\n/* .Graduates-sections a {\n  text-align: right;\n\n}\n.aside-Graduates .actives{\nbackground-color: #0586bc !important;\n} */\n/* Start modal shown  */\n.modal-content-home .modal-content {\n  width: 750px !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, 0);\n}\n\n.modal-content-home .btn-close-modal {\n  position: absolute;\n  left: 20px;\n}\n\n@media (max-width:768px) {\n  .modal-content-home .modal-content {\n    width: 500px !important;\n  }\n}\n\n@media (max-width:567px) {\n  .modal-content-home .modal-content {\n    width: 300px !important;\n  }\n}\n\n/* End modal shown  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
